import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connectToStores} from 'fluxible-addons-react';
import {processPasswordReset, updateResetPasswordFormState} from '../../../actions/AuthenticationActionCreators';
import {FormattedMessage, intlShape} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import AccountMessages from './AccountMessages';
import CommonMessages from '../../../intl/CommonMessages';
import FormState from '../../../constants/FormState';
import cx from 'classnames';

@connectToStores(['ResetPasswordStore'], (context) => {
  const ResetPasswordStore = context.getStore('ResetPasswordStore');

  return {
    emailAddress: ResetPasswordStore.getEmailAddress()
  };
})
class ResetPasswordForm extends Component {

  static propTypes = {
    emailAddress: PropTypes.string.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      errors: []
    };
  }

  processReset = () => {
    this.context.executeAction(processPasswordReset, {
      password: this.state.password
    });
  };

  handleMainPasswordChanged = event => {
    const {
      confirmPassword
    } = this.state;
    this.updateFormData({
      password: event.target.value,
      confirmPassword
    });
  };

  handleConfirmPasswordChanged = event => {
    const {
      password
    } = this.state;
    this.updateFormData({
      confirmPassword: event.target.value,
      password
    });
  };

  updateFormData = state => {
    const { password, confirmPassword } = state;

    const errors = {};

    let hasErrors = false;

    // this one is OK, as this is simply for form validation, not for actual password hash comparison
    // eslint-disable-next-line security/detect-possible-timing-attacks
    if (password === '') {
      errors.password = [CommonMessages.required];
      hasErrors = true;
    }

    // The string must be eight characters or longer
    if (!/(?=.{8,})/.test(password) ) {
      errors.password = [CommonMessages.tooShort];
      hasErrors = true;
    }

    //  test strong password 
    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/

    if (password !== confirmPassword && confirmPassword !== '') {
      errors.confirmPassword = [AccountMessages.passwordsNotEqual];
      hasErrors = true;
    }

    const formState = hasErrors ?
      FormState.ERROR :
      (password === '' || confirmPassword === '') ? FormState.INITIAL : FormState.VALID;
    this.context.executeAction(updateResetPasswordFormState, formState);
    this.setState({
      ...state,
      formState,
      errors
    });
  };

  render() {
    const { emailAddress } = this.props;
    const { password, confirmPassword, formState, errors } = this.state;

    const intl = this.context.intl;
    const emailAddressText = intl.formatMessage(AccountMessages.emailAddress);
    const passwordText = intl.formatMessage(AccountMessages.password);
    const confirmPasswordText = intl.formatMessage(AccountMessages.confirmPassword);
    const formValid = formState === FormState.VALID;

    const generateClasses = (fieldName, showFormErrors) => {
      const fieldHasErrors = (errors[fieldName] || []).length > 0;
      const classes = {
        'form-group': true
      };

      if (showFormErrors && formState !== FormState.INITIAL) {
        const errorType = fieldHasErrors ? 'has-danger' : 'has-success';
        classes[errorType] = true;
      }

      return cx(classes);
    };

    const confirmPasswordClasses = generateClasses('confirmPassword', confirmPassword !== '');
    const passwordClasses = generateClasses('password', true);

    const formProcessing = formState === FormState.PROCESSING;

    const message = formProcessing ?
      <FontAwesome name="cog" spin/> :
      <FormattedMessage { ...CommonMessages.reset } />;

    const passwordErrors = (errors.password || []).map(err => {
      return <FormattedMessage { ...err } values={ {fieldName: 'Password'} }/>;
    });

    const confirmPasswordErrors = (errors.confirmPassword || []).map(err => {
      return <FormattedMessage { ...err } />;
    });

    const formData = {
      emailAddress,
      password,
      confirmPassword
    };

    return <form className="login">
      <fieldset className="form-group">
        <label className="sr-only" htmlFor="emailAddress">
          { emailAddressText }
        </label>
        <div className="input-group">
          <input type="email" className="form-control" name="emailAddress"
                 placeholder={ emailAddressText }
                 value={formData.emailAddress}
                 disabled/>
          <div className="input-group-append">
            <span className="input-group-text"><FontAwesome name="envelope"/></span>
          </div>
        </div>
      </fieldset>
      <fieldset className={ passwordClasses }>
        <label className="sr-only" htmlFor="password">
          { passwordText }
        </label>
        <div className="input-group">
          <input type="password"
                 className="form-control form-control-danger form-control-success"
                 name="password"
                 placeholder={ passwordText }
                 onChange={this.handleMainPasswordChanged}
          />
          <div className="input-group-append">
            <span className="input-group-text"><FontAwesome name="lock"/></span>
          </div>
        </div>
        <div className="text-help">
          { passwordErrors }
        </div>
      </fieldset>

      <fieldset className={ confirmPasswordClasses }>
        <label className="sr-only" htmlFor="password">
          { confirmPasswordText }
        </label>
        <div className="input-group">
          <input type="password"
                 className="form-control form-control-danger form-control-success"
                 name="confirmPassword"
                 placeholder={ confirmPasswordText }
                 onChange={this.handleConfirmPasswordChanged}
          />
          <div className="input-group-append">
            <span className="input-group-text"><FontAwesome name="lock"/></span>
          </div>
        </div>
        <div className="text-help">
          { confirmPasswordErrors }
        </div>
      </fieldset>

      <button className="btn btn-primary" type="submit" disabled={ !formValid } onClick={this.processReset}>
        { message }
      </button>
    </form>;
  }

}

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/apps/Account/components/ResetPasswordForm.js